<template>
  <div class="tn-travel-filter">
    <div class="mobile-header">
      <h4>Reisefilter</h4>
      <button
          type="button"
          class="close-filter"
          @click="hide()"
      ><span class="sr-only">Close</span></button>
    </div>
    <div class="content">
      <div class="facet">
        <h4>Reisepreis</h4>
        <PriceRange @update:range="updatePriceRange($event)" style="margin-bottom: 20px;" :histogram="priceHistogram"/>
      </div>
      <div class="facet">
        <h4>Reisedauer</h4>
        <ul>
          <li v-for="(duration, key) in getFacets.durations"
              :key="key"
              :class="{'disabled': duration.count === 0 }"
          ><label class="radio">
            <input type="checkbox"
                   :value="duration.slug"
                   :disabled="duration.count === 0"
                   @input="setDurationState( duration.slug, $event.target.checked)"
            ><i></i>
            <span class="text">{{ duration.label }}</span>
            <span class="result-count">{{ duration.count }}</span>
          </label></li>
        </ul>
      </div>
      <div v-for="taxonomy in getFacets.taxonomies"
           :key="taxonomy.slug"
           class="facet"
      >
        <h4>{{ taxonomy.label }}
          <button
              v-if="getFilter[taxonomy.slug] && getFilter[taxonomy.slug].length > 0"
              @click.prevent="removeFilter(taxonomy)"
              type="button"
              class="reset-filter"><i class="eicon-close"></i></button></h4>
        <ol>
          <li v-for="term in getSortedTerms(taxonomy)"
              :key="term.slug"
              :class="{'disabled': term.count === 0 }"
          ><label>
            <input type="checkbox"
                   :value="term.slug"
                   :disabled="term.count === 0"
                   :checked="getFilter[taxonomy.slug] && getFilter[taxonomy.slug].includes(term.slug)"
                   @input="setTaxonomyTermState(taxonomy, term, $event.target.checked)"
            ><i></i>
            <span class="text">{{ term.label }}</span>
            <span class="result-count">{{ term.count }}</span>
          </label></li>
        </ol>
        <span role="button"
              v-if="getTerms(taxonomy).length > 5"
              @click.prevent="toggleShowMore(taxonomy)">
        <span v-if="!isShowMore(taxonomy)">mehr anzeigen</span>
        <span v-else>weniger anzeigen</span>
      </span>
      </div>
    </div>
  </div>
</template>

<script>
import PriceRange from "./PriceRange";
import {mapActions, mapGetters} from "vuex";
export default {
  name: "TnTravelFilter",
  components: {PriceRange},
  data: () => ({
    facetState: {

    }
  }),
  computed: {
    ...mapGetters(['getFacets', 'getFilter']),
    selectedDuration: {
      get() {
        return this.$store.state.filter.duration;
      },
      set(value) {
        this.$store.dispatch('updateFilter', {
          duration: value
        });
      }
    },
    // taxonomyFacets() {
    //   const facets = this.getFacets.taxonomies;
    //   facets.sort((a, b) => {
    //     if (a.count !== b.count) {
    //       return a.count - b.count;
    //     }
    //   });
    //
    //   return;
    // },
    priceHistogram() {
      let graph = {
        data: []
      };
      const priceRange = this.getFacets.price_range;
      if (!priceRange) {

        return graph;
      }

      for (let key = 0; key <= 3000; key = key + 50) {
        const bucketKey = key.toFixed(1);
        if (priceRange[bucketKey] && typeof priceRange[bucketKey].count === 'number') {
          graph.data.push(priceRange[bucketKey].count);
        } else {
          graph.data.push(0);
        }
      }

      return graph;
    }
  },
  methods: {
    ...mapActions([
      'removeFilter',
      'addFilterDuration', 'removeFilterDuration',
      'addFilterTerm', 'removeFilterTerm'
    ]),
    updatePriceRange(range) {
      this.$store.dispatch('updateFilter', {
        price_range: range
      });
    },
    initState(taxonomy) {
      if (!this.facetState[taxonomy.slug]) {
        this.$set(this.facetState, taxonomy.slug, {
          showMore: false
        });
      }
    },

    isShowMore(taxonomy) {
      this.initState(taxonomy);
      return this.facetState[taxonomy.slug].showMore;
    },

    isSelected(taxonomy, term) {
      return this.getFilter[taxonomy.slug]
          && this.getFilter[taxonomy.slug].includes(term.slug);
    },

    getTerms(taxonomy) {
      return Object.values(taxonomy.terms);
    },

    getSortedTerms(taxonomy) {
      const terms = this.getTerms(taxonomy);
      const isSelected = (term) => {
        return this.isSelected(taxonomy, term);
      };
      if (this.isShowMore(taxonomy)) {
        // sort by name
        terms.sort((a,b) => {
          return a.slug.localeCompare(b.slug);
        });

        return terms;
      } else {
        // sort by selected, count and name
        terms.sort((a,b) => {
          if (isSelected(a) !== isSelected(b)) {
            return isSelected(a) ? -1 : 1;
          }
          if (a.count !== b.count) {
            return b.count - a.count;
          }
          return a.slug.localeCompare(b.slug);
        });

        return terms.slice(0, 5);
      }
    },

    toggleShowMore(taxonomy) {
      this.initState(taxonomy);
      this.facetState[taxonomy.slug].showMore = !this.facetState[taxonomy.slug].showMore;
    },

    setDurationState(duration, state) {
      if (state) {
        this.addFilterDuration(duration);
      } else {
        this.removeFilterDuration(duration);
      }
    },

    setTaxonomyTermState(taxonomy, term, state) {
      if (state) {
        this.addFilterTerm({taxonomy, term});
      } else {
        this.removeFilterTerm({taxonomy, term});
      }
        console.log('setState', taxonomy, term, state);
    },

    hide() {
      window.document.getElementsByTagName('HTML')[0].classList.remove('filter-opened');
    }
  }
}
</script>

<style scoped lang="scss">
  .mobile-header {
    display: none;

    h4 {
      font-size: 32px;
      font-weight: 400;
    }
    .close-filter {
      position: absolute;
      right: 5px;
      top: 5px;
    }
  }
  .content {
    margin: 0px -10px;
    padding: 15px;
  }
  pre {
    color: #000;
    padding: 5px;
  }
  .facet {
    font-size: 16px;
  }
  .facet h4 {
    font-size: 1.2em;
    //border-bottom: 1px solid #fff;
    margin-bottom: 5px;
    font-weight: 400;
  }
  .tn-travel-filter {
    color: #ffffff;

      h3, h4, h5 {
        color: #ffffff;
      }

    ul, ol {
      padding: 0;
      margin: 0;
    }
    li {
      list-style-type: none;
      line-height: 1.2;
    }
  }

  .result-count {
    background-color: #ea7819;
    border-radius: 5px;
    padding: 0px 5px;
    font-size: 0.8em;
    font-weight: 700;
    margin-left: 10px;
    line-height: 1;
  }

  label > .text {
    margin-left: 10px;
  }

  button.reset-filter {
    padding: 5px;
    border-radius: 50%;
    color: #fff;
    margin-left: 5px;
  }

  .facet {
    margin-bottom: 15px;
  }

  [role="button"] {
    cursor: pointer;
    //border: 1px solid #fff;
    color: #fff;
    //padding: 5px 10px;
  }
  //[role="button"]:hover,
  //[role="button"]:active {
  //  border-bottom: 1px solid #fff;
  //}

  @media screen and (max-width: 1023px) {
    .mobile-header {
      display: block;
    }
  }
</style>
<style lang="scss">
@media screen and (max-width: 1023px) {
  #sidebar-filter {
    display: none;
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    max-width: 360px;
    z-index: 999;
    background: #910a0a;
    box-shadow: -5px 0px 5px 0px #0003;

    &>*:first-child {
      height: 100%;
      position: relative;

      .elementor-element {
        height: 100%;
      }
      .content {
        margin: 0px -10px;
        padding: 15px;
        position: absolute;
        top: 50px;
        bottom: 0;
        left: 0;
        right: 0;
        overflow-y: auto;
      }
    }
  }

  .filter-opened {
    #sidebar-filter {
      display: block;
    }
  }
}
</style>
